// 导入所有 group 模块的国际化文件
import { messages as refundGroupOrderMessages } from '@/lang/group/refundGroupOrderLang.js'
import { messages as adminGroupMessages } from '@/lang/group/adminGroupLang.js'
import { messages as adminGroupOrderMessages } from '@/lang/group/adminGroupOrderLang.js'
import { messages as adminSeckillMessages } from '@/lang/group/adminSeckillLang.js'
import { messages as adminSeckillOrderMessages } from '@/lang/group/adminSeckillOrderLang.js'
import { messages as groupMessages } from '@/lang/group/groupLang.js'
import { messages as productGroupMessages } from '@/lang/group/productGroupLang.js'
import { messages as productGroupOrderMessages } from '@/lang/group/productGroupOrderLang.js'
import { messages as productGroupOrderReturnMessages } from '@/lang/group/productGroupOrderReturnLang.js'
import { messages as productSeckillMessages } from '@/lang/group/productSeckillLang.js'
import { messages as productSeckillOrderMessages } from '@/lang/group/productSeckillOrderLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...refundGroupOrderMessages.en,
        ...adminGroupMessages.en,
        ...adminGroupOrderMessages.en,
        ...adminSeckillMessages.en,
        ...adminSeckillOrderMessages.en,
        ...groupMessages.en,
        ...productGroupMessages.en,
        ...productGroupOrderMessages.en,
        ...productGroupOrderReturnMessages.en,
        ...productSeckillMessages.en,
        ...productSeckillOrderMessages.en
    },
    zh: {
        ...refundGroupOrderMessages.zh,
        ...adminGroupMessages.zh,
        ...adminGroupOrderMessages.zh,
        ...adminSeckillMessages.zh,
        ...adminSeckillOrderMessages.zh,
        ...groupMessages.zh,
        ...productGroupMessages.zh,
        ...productGroupOrderMessages.zh,
        ...productGroupOrderReturnMessages.zh,
        ...productSeckillMessages.zh,
        ...productSeckillOrderMessages.zh
    }
} 